/* eslint-disable max-len */
import 'react';

let index = 0;

const PPTSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const date = index++;
    const id = `ppt-1-${date}`;
    const id2 = `ppt-2-${date}`;

    return (
        <svg width="1em" height="1em" viewBox="0 0 26 26" {...props}>
            <defs>
                <linearGradient
                    x1="15.244%"
                    y1="0%"
                    x2="84.756%"
                    y2="100%"
                    id={id}
                >
                    <stop stopColor="#FE997A" offset=".09%" />
                    <stop stopColor="#FF706F" offset="100%" />
                </linearGradient>
                <linearGradient
                    x1="50%"
                    y1="0%"
                    x2="50%"
                    y2="81.112%"
                    id={id2}
                >
                    <stop stopColor="#FFF" stopOpacity={0.96} offset="0%" />
                    <stop stopColor="#FFF" stopOpacity={0.8} offset="100%" />
                </linearGradient>
            </defs>
            <g fill="none" fillRule="evenodd">
                <path d="M1.857 2.1h22.286v22.286H1.857z" />
                <path
                    d="M2.98 0h12.18a5.278 5.278 0 015.278 5.278v14.203a2.805 2.805 0 01-2.805 2.805H4.662a2.805 2.805 0 01-2.805-2.805V1.12C1.857.503 2.36 0 2.98 0z"
                    fill={`url(#${id})`}
                    transform="translate(1.857 2.1)"
                />
                <path
                    d="M13.49 7.624c1.673 0 3.029 1.313 3.029 2.932 0 1.58-1.29 2.868-2.906 2.93l-.122.003h-1.746v2.639a.88.88 0 01-1.755.085l-.004-.085V8.504a.88.88 0 01.668-.854v-.026h2.837zm-5.475 7.33A.88.88 0 018.1 16.71l-.085.004H6.842a.88.88 0 01-.085-1.755l.085-.004h1.173zm0-3.518a.88.88 0 01.085 1.755l-.085.004H6.842a.88.88 0 01-.085-1.755l.085-.004h1.173zm5.476-2.212h-1.746v2.665h1.746c.76 0 1.376-.596 1.376-1.333 0-.706-.568-1.285-1.286-1.33l-.09-.002zM8.015 7.917A.88.88 0 018.1 9.673l-.085.004H6.842a.88.88 0 01-.085-1.756l.085-.004h1.173z"
                    fill={`url(#${id2})`}
                    transform="translate(1.857 2.1)"
                />
            </g>
        </svg>
    );
};

export default PPTSvg;
